import React, { useMemo } from "react";
import ApexCharts from "react-apexcharts";
import { useSelector, useDispatch } from 'react-redux';

// Mavi tonlarından oluşan renk paleti
const blues = [
  ["#0086c2"], // Bir ton mavi
  ["#0086c2", "#6085d5", "#a27dd8"], // Üç ton mavi
  ["#0086c2", "#6085d5", "#a27dd8", "#d671c7"], // Dört ton mavi
  ["#0086c2", "#6085d5", "#a27dd8", "#d671c7", "#ff68a5"], // Beş ton mavi
  ["#0086c2", "#6085d5", "#a27dd8", "#d671c7", "#ff68a5","#ff6e79"],
  ["#0086c2", "#6085d5", "#a27dd8", "#d671c7", "#ff68a5","#ff6e79","#ff8649"],
  ["#0086c2", "#6085d5", "#a27dd8", "#d671c7", "#ff68a5","#ff6e79","#ffa600",],
];

// Renk hesaplama fonksiyonu
const getColor = (length, index) => {
  if (length <= blues.length) {
    return blues[length - 1][index];
  }
  return blues[blues.length - 1][index % blues.length];
};

// Text ölçüsü hesaplama fonksiyonu
let ctx;
export const measureText14HelveticaNeue = (text) => {
  if (!ctx) {
    ctx = document.createElement("canvas").getContext("2d");
    ctx.font = "14px 'Helvetica Neue'";
  }
  return ctx.measureText(text).width;
};

const ResultBarChart = ({ data, yKey, xKey }) => {
  
  const themeMode = useSelector(state => state.themeMode);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);
  const maxTextWidth = useMemo(() => {
    return data.reduce((maxWidth, d) => {
      const textWidth = measureText14HelveticaNeue(d[xKey]);
      return Math.max(maxWidth, textWidth);
    }, 0);
  }, [data, xKey]);
  // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
  const chartHeight =
  data.length <=5?data.length*75:data.length<=10?data.length*65:data.length<=15?data.length*60:data.length*55
  const rowHeight=chartHeight/data.length
  const barHeight = data.length>5?rowHeight * 0.65:rowHeight * 0.55; 
  const barGap=(chartHeight/data.length)*(1-(barHeight/100))
  const chartOptions = {
    chart: {
      type: "bar",
      height: 400,
      width:"100%",
      toolbar: {
        show: false,
      },
    },
    grid: {
      show: false,  // Grid çizgilerini gizler
    },
    tooltip: {
      enabled: false,  // Tooltip'i devre dışı bırakır
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: `${barHeight}px`, 
        distributed: true,
        borderRadius: 15,
        barGap:20,
        dataLabels: {
          position: 'center', // Değerleri barların üstüne koyar
        },
      },
    },
    xaxis: {
      categories: data.map(d => d[xKey]),
      labels: {
        show: false,  // X eksenindeki değerleri gizler
      },
      axisBorder: {
        show: false, // X ekseni çizgisini gizler
      },
      axisTicks: {
        show: false, // X ekseni tiklerini gizler
      },
    },
    yaxis: {
      labels: {
        show:false,
        style: {
          colors: themeMode === "dark" ? "#fff" : "#000",
          fontSize: "14px",
          width: "400px"
        },
      },
      tooltip: {
        enabled: false,
      },
    },
    fill: {
      type: "solid",
      colors: data.map((_, idx) => getColor(data.length, idx)),
    },
    dataLabels: {
      enabled: true, // Değerleri göster
      style: {
        colors: ["#fff"],
        fontSize: "14px",
        fontWeight: "bold",
      },
      formatter: function (val) {
        return val !== 0 ? val.toLocaleString() : "";
      },
    },
    legend: {
      show: false,
    },
  };
  
  

  const chartSeries = [
    {
      data: data.map((d) => d[yKey].toFixed(1)),
    },
  ];
  return (
    <div style={{display: "flex", alignItems: "center", width: "100%", height:"auto" }} >
        {/* Y ekseni için ayrı bir container */}
    <div style={{  width: `${maxTextWidth + 100}px`, textAlign: "left",height:`${chartHeight+15}px`, maxWidth:"60%" ,transform: "translateY(5px)" }} className={`${data.length>5?"mt-8":data.length>2?"mt-12":"mt-8"}`} >
      {data.map((d, idx) => (
      <div key={idx} style={{
        height: `${barHeight+barGap/2}px`,
       
        lineHeight: `${barHeight+barGap/2}px`,
        fontSize: "14px",
        maxWidth: `${maxTextWidth + 100}px`
    }}>
    
          <div style={{        overflow: "hidden", // Taşmaları gizler
        textOverflow: "ellipsis", // Uzun metinlerde "..." ekler
        whiteSpace: "nowrap",
        }}>
          {d[xKey]}
          </div>
          {idx !== data.length - 1 && (
      <div
        style={{
          width: "100%",
          backgroundColor: "#D6CFCF", // Divider rengi
          height: "0.3px", // Divider yüksekliği
        }}
      ></div>
    )}
        </div>
    
      ))}
    </div>
       {/* Grafik Container */}
       <div style={{ flex: 1 }}>
      <ApexCharts
        options={chartOptions}
        series={chartSeries}
        type="bar"
        height={chartHeight}
      />
    </div>
    </div>
  );
};

export default ResultBarChart;
